<template>
  <g
    id="ic_course_star"
    transform="translate(45 -22)"
  >
    <path
      id="Pfad_1026"
      data-name="Pfad 1026"
      d="M0,0H24V24H0Z"
      transform="translate(-45 22)"
      fill="none"
      opacity="0.87"
    />
    <g
      id="Gruppe_892"
      data-name="Gruppe 892"
      transform="translate(-43.8 23.5)"
    >
      <path
        id="Pfad_1131"
        data-name="Pfad 1131"
        d="M11.036,4,8.369,3.769l-1.3-.108-.508-1.2L5.518,0,4.471,2.462l-.508,1.2-1.3.108L0,4l2.03,1.76.983.853L2.721,7.872l-.616,2.613L4.406,9.1l1.112-.68L6.63,9.1l2.3,1.382L8.315,7.872,8.023,6.609l.983-.853Z"
        transform="translate(5.281 5.54)"
        fill="#ffe781"
      />
      <path
        id="Pfad_1132"
        data-name="Pfad 1132"
        d="M21.6,7.818,13.833,7.16,10.8,0,7.764,7.16,0,7.818l5.9,5.108L4.125,20.518,10.8,16.49l6.674,4.028L15.7,12.926Zm-8,5.594.6,2.6-2.289-1.382-1.112-.67-1.112.67L7.4,16.015l.6-2.6.292-1.274-.983-.853-2.03-1.76L7.948,9.3l1.3-.108.508-1.2L10.8,5.54l1.047,2.473.508,1.2,1.3.108,2.667.227-2.03,1.76-.983.853.292,1.253Z"
        fill="#ffc400"
      />
    </g>
  </g>
</template>
